<template>
    <div class="card mb-3">
        <div class="card-header">
            <strong>Personnel Fields</strong>
        </div>
        <div class="card-body">

            <div v-for="(field, i) in personnel">
                <div class="row">
                    <div class="col-lg-3 text-muted text-lg-right">
                        <a href="javascript:void(0)" v-on:click="deletePersonnel(i)"><i class="fa fa-trash text-danger"></i></a> Label:
                    </div>
                    <div class="col-lg-6">
                        <b-form-input v-model="field.field_label" size="sm" placeholder="Enter Personnel Label, e.g. Supervisor, Superintendent, etc." />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 text-muted text-lg-right">Required:</div>
                    <div class="col-lg-6">
                        <b-form-checkbox v-model="field.is_required" :value="1" :unchecked-value="0" plain />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 text-muted text-lg-right">
                        Allow Other <i class="fa fa-question-circle" title="If checked, users will be able to enter enter an Other Name as plain text instead of linking it to an employee."></i>:
                    </div>
                    <div class="col-lg-6">
                        <b-form-checkbox v-model="field.is_allow_other" :value="1" :unchecked-value="0" plain />
                    </div>
                </div>
                <hr />
            </div>

            <div id="new-personnel" class="text-center" v-on:click="addPersonnel()">
                <span class="text-success"><i class="fa fa-plus-circle"></i> Add Personnel Field</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            personnel: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {

            }
        },

        watch: {
            personnel(newVal, oldVal){
                //Emit it
                this.$emit('personnelChanged', this.personnel);
            }
        },

        computed: {


        },

        methods: {
            getPersonnel(){
                //Send it
                return this.personnel;
            },

            addPersonnel(){
                //Push New
                this.personnel.push({
                    field_label: '',
                    is_required: 0,
                    is_allow_other: 0,
                });
            },

            deletePersonnel(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this Personnel field?'))
                {
                    return;
                }

                //Splice
                this.personnel.splice(i, 1);
            }
        },

        mounted(){
            //Set the personnel that was passed it?
        }
    }
</script>

<style type="text/css" scoped>
    #new-personnel {
        padding: 5px 8px;
        border: 1px dashed #ccc;
    }

    #new-personnel:hover {
        cursor: pointer;
    }
</style>
